/* eslint-disable no-await-in-loop, no-console */
import axios from 'axios';
import * as TraceKit from 'tracekit';

import { apiUrl } from '../../pro/config';

export default class ErrorHandler {

    constructor(appName = 'pro-react') {
        this.appName = appName;
        this.report = this.report.bind(this);
        this.handleError = this.handleError.bind(this);
        TraceKit.collectWindowErrors = false;
    }

    async formatError(error) {
        const formatedError = {
            type: 'error',
            app: this.appName,
            title: `${error.name}::${error.message}`,
            message: error.message,
            page: window.location.href,
            file: null,
            line: null,
            code: null,
            trace: '',
        };
        if (error.stack && error.stack.length > 0) {
            Object.assign(formatedError, {
                file: error.stack[0].file,
                line: error.stack[0].line,
                code: error.stack[0].context,
                trace: JSON.stringify(error.stack),
            });
        }
        return formatedError;
    }

    async sendError(error) {
        const formatedError = await this.formatError(error);
        const headers = {};
        if (window.YP_API && window.YP_API.ACCESS_TOKEN ? window.YP_API.ACCESS_TOKEN : false) {
            headers.Authorization = `Bearer ${window.YP_API.ACCESS_TOKEN}`;
        }
        axios.post(`${apiUrl}/god`, formatedError, { headers })
            .then(() => {
                (console.warn || console.log)('Error has been sent', formatedError);
            })
            .catch((e) => {
                (console.error || console.log)('Error while sending error', e);
            });
    }

    async handleError(tracKitError) {
        console.error(tracKitError);
        try {
            await this.sendError(tracKitError);
        } catch (e) {
            (console.error || console.log)('ErrorsHelpers::handleError', e);
        }
    }

    report(error) {
        TraceKit.report(error);
    }

    bindErrorsListeners() {
        TraceKit.report.subscribe(this.handleError);
    }

    unbindErrorsListeners() {
        TraceKit.report.unsubscribe(this.handleError);
    }

}
